export default __webpack_public_path__ + "static/media/image1.a7cf60a3.png";